'use client'

import { useState } from 'react'
import { default as NextImage, ImageProps } from 'next/image'

const Image = ({ className, priority, ...props }: ImageProps) => {
  const [loaded, setLoaded] = useState(false)

  return (
    <NextImage
      className={`inline-block align-top transition-opacity ${
        priority || loaded ? 'opacity-100' : 'opacity-0'
      } ${className}`}
      onLoad={() => setLoaded(true)}
      priority={priority}
      {...props}
    />
  )
}

export default Image
